import './metaAttribution'
import { agentCodeFromUrl, getInitAgentCode } from './initAgentCode'

const key = 'pwa.11ic.source.v1'
const lifetime = 90 * 86400000
let memory
export function landingRoute (pathname = window.location.pathname) {
  const match = /^\/install\/(0[1-5])(?:\/|\/index\.html)?$/.exec(pathname)
  return match ? '/install/' + match[1] : ''
}
export function normalizePixelId (value) {
  if (typeof value === 'number' && (!Number.isSafeInteger(value) || value <= 0)) return ''
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  const id = String(value).trim()
  return /^[1-9]\d*$/.test(id) ? id : ''
}
function valid (value) {
  return value && landingRoute(value.routeAddress) === value.routeAddress &&
    typeof value.visitId === 'string' && !!value.visitId && typeof value.created === 'number' &&
    typeof value.agentCode === 'string' && typeof value.clickId === 'string' &&
    value.created > Date.now() - lifetime && value.created <= Date.now() &&
    (value.pixelId === null || normalizePixelId(value.pixelId) === value.pixelId)
}
function sharedSource () {
  const values = []
  try { values.push(JSON.parse(window.localStorage.getItem(key))) } catch (e) {}
  try {
    const cookie = document.cookie.split(/;\s*/).find(item => item.indexOf(key + '=') === 0)
    if (cookie) values.push(JSON.parse(decodeURIComponent(cookie.slice(key.length + 1))))
  } catch (e) {}
  return values.filter(valid).sort((a, b) => b.created - a.created)[0] || null
}
function save (value, newVisit = false) {
  const previous = memory
  memory = value
  const encoded = JSON.stringify(value)
  try { window.sessionStorage.setItem(key, encoded) } catch (e) {}
  // An older tab may finish its API request after a newer landing tab. Keep its
  // own session, but don't overwrite the newer source used by desktop launches.
  const shared = sharedSource()
  const candidate = value || previous
  if (!newVisit && shared && (!candidate || shared.visitId !== candidate.visitId) &&
    (!value || shared.created >= value.created)) return value
  try { window.localStorage.setItem(key, encoded) } catch (e) {}
  // Host-only: all five landing pages and the installed application share the H5 origin.
  try {
    document.cookie = key + '=' + encodeURIComponent(encoded) + ';path=/;max-age=' +
      (value ? Math.max(0, Math.floor((value.created + lifetime - Date.now()) / 1000)) : 0) +
      ';SameSite=Lax' + (window.location.protocol === 'https:' ? ';Secure' : '')
  } catch (e) {}
  return value
}
export function getLandingSource () {
  if (window.__elevenIcPwa !== true) return null
  if (memory === undefined) {
    let session
    let cleared = false
    try {
      const stored = window.sessionStorage.getItem(key)
      cleared = stored === 'null'
      session = JSON.parse(stored)
    } catch (e) {}
    // Session storage preserves a tab's own campaign; local storage restores a new PWA window.
    // If a storage write failed, the cookie may contain a newer source than localStorage.
    // Explicitly clearing this tab's source must survive refresh, even when
    // another tab has a newer landing saved in the shared stores.
    memory = cleared ? null : (valid(session) ? session : sharedSource())
  }
  const agent = agentCodeFromUrl()
  const click = window.__metaAttribution.restore()
  // Carry only the public route across navigation, never trust a Pixel ID from
  // the URL. This also recovers the correct source when storage is unavailable.
  let incomingRoute = ''
  try { incomingRoute = landingRoute(new URL(window.location.href).searchParams.get('landing_route') || '') } catch (e) {}
  if (!landingRoute() && incomingRoute && (!valid(memory) || memory.routeAddress !== incomingRoute ||
    (agent && agent !== memory.agentCode) ||
    (/[?&]fbclid=/.test(window.location.href) && click && click.id !== memory.clickId))) {
    return beginLandingVisit(incomingRoute)
  }
  if (!valid(memory)) return memory ? save(null) : null
  const currentCode = agent || getInitAgentCode()
  // An explicit new non-landing campaign must not inherit the previous landing Pixel.
  if (!landingRoute() && ((currentCode && currentCode !== memory.agentCode) ||
    (/[?&]fbclid=/.test(window.location.href) && click && click.id !== memory.clickId))) return save(null)
  return memory
}
export function beginLandingVisit (routeAddress) {
  if (!landingRoute(routeAddress)) return null
  const click = window.__metaAttribution.restore()
  return save({
    routeAddress, pixelId: null, agentCode: getInitAgentCode(),
    clickId: click ? click.id : '', created: Date.now(),
    visitId: Date.now() + ':' + Math.random().toString(36).slice(2)
  }, true)
}
export function resolveLandingPixel (visit, value) {
  const pixelId = normalizePixelId(value)
  if (!pixelId || !memory || memory.visitId !== visit.visitId) return null
  return save(Object.assign({}, memory, { pixelId }))
}
export function landingScope (source) {
  return source ? source.routeAddress + ':' + source.agentCode : ''
}
export function applyLandingPixel (config, source) {
  // The current /init response is authoritative for every entry. Stored landing
  // IDs are historical metadata and must never override an agent's latest config.
  return Object.assign({}, config, {
    metaTrackingPending: false,
    landingRoute: source ? source.routeAddress : ''
  })
}



// WEBPACK FOOTER //
// ./src/common/utils/landingAttribution.js